import { useEffect } from "react";

const BASE = "https://pilcoo-live.preview.emergentagent.com";
const DEFAULT_TITLE = "The PilCoo Foundation | Animals, Mental Wellbeing & Nature";
const DEFAULT_DESC =
  "The PilCoo Foundation is a Bengaluru-based compassion-led initiative bringing people together for animal welfare, mental wellbeing and environmental action.";

export default function SEO({ title, description, path = "/", image }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — The PilCoo Foundation` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", `${BASE}${path}`);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", image || `${BASE}/brand/og-image.png`);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BASE}${path}`);
  }, [title, description, path, image]);

  return null;
}
